// Ваш основной файл index.js

import { createStore } from "vuex";
import User from './modules/user'
import Meeting from './modules/meeting'

export default createStore({
  modules: {
    user: User,
    meeting: Meeting
  }
  
});
